import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loading = new BehaviorSubject<boolean>(false);

  get _loading() {
    return this.loading.asObservable();
  }

  constructor() {
  }

  show() {
    Promise.resolve().then(() => this.loading.next(true));
  }

  hide() {
    Promise.resolve().then(() => this.loading.next(false));
  }
}
